import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/mails',
  component: mainLayout(loadView('mail/Mail')),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'MailList',
      component: loadView('mail/MailList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'threads/new/:actor_id',
      name: 'MailBoxNew',
      component: loadView('mail/MailBox'),
      props: route => ({
        type: 'new',
        actor_id: Number(route.params.actor_id)
      }),
      meta: { requiresAuth: true }
    },
    {
      path: 'threads/received/:actor_id',
      name: 'MailBoxReceived',
      component: loadView('mail/MailBox'),
      props: route => ({
        type: 'received',
        actor_id: Number(route.params.actor_id)
      }),
      meta: { requiresAuth: true }
    },
    {
      path: 'threads/read/:actor_id',
      name: 'MailBoxRead',
      component: loadView('mail/MailBox'),
      props: route => ({
        type: 'read',
        actor_id: Number(route.params.actor_id)
      }),
      meta: { requiresAuth: true }
    },
    {
      path: 'threads/new',
      name: 'MailThreadsNew',
      component: loadView('mail/MailThreads'),
      props: { type: 'new' },
      meta: { requiresAuth: true }
    },
    {
      path: 'threads/received',
      name: 'MailThreadsReceived',
      component: loadView('mail/MailThreads'),
      props: { type: 'received' },
      meta: { requiresAuth: true }
    },
    {
      path: 'threads/read',
      name: 'MailThreadsRead',
      component: loadView('mail/MailThreads'),
      props: { type: 'read' },
      meta: { requiresAuth: true }
    },
    {
      path: ':type/:id/image',
      name: 'MailImage',
      component: loadView('mail/MailImage'),
      meta: { requiresAuth: true }
    },
    {
      path: ':type/:id',
      name: 'MailDetail',
      component: loadView('mail/MailDetail'),
      meta: { requiresAuth: true }
    }
  ]
}
